module.exports = __webpack_public_path__ + "5a2df9aadcfacd43aca889ee73405998.png";